import { render, staticRenderFns } from "./CustomizerNewHeader.vue?vue&type=template&id=4a46a990"
import script from "./CustomizerNewHeader.vue?vue&type=script&lang=js"
export * from "./CustomizerNewHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports